import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TotalCumulCard = (props) => {

    return (
        <div className="d-flex col-xs-12 col-md-6 col-xl-3">
            <div className="card bg-fog">
                <div className="card-body text-center">
                    <FontAwesomeIcon icon={props.icon} size="3x" color="#FFF" className="mt-2"  />
                    <h1 className="body-color mt-3">{props.value}</h1>
                    <h4 className="text-muted mt-2">{props.title}</h4>
                    <p className="text-muted text-uppercase" style={{letterSpacing:".2rem"}}>{props.subTitle}</p>
                </div>
            </div>
        </div>
    );   
}

export default (TotalCumulCard);